class ExpandableSearch extends HTMLElement {
  constructor() {
    super();

    this.expandSearchButton = document.querySelector('#expandable-search-button');
    this.expandSearchButton.addEventListener('click', this.showSearch.bind(this));

    this.querySelector('.collapse-button').addEventListener('click', this.hideSearch.bind(this));
    this.addEventListener('keyup', (event) => {
      if(event.code === 'Escape') {
        this.hideSearch();
      }
    })
    this.searchForm = this.querySelector('.expandable-search__form');

    this.searchInput = this.querySelector('expandable-search .search__input');
  }

  showSearch() {
    this.classList.remove('hidden');
    this.expandSearchButton.classList.add('visibility-hidden', 'hidden');
    this.searchInput.focus();
  }

  hideSearch() {
    this.classList.add('hidden');
    this.expandSearchButton.classList.remove('visibility-hidden', 'hidden');
  }
}

customElements.define("expandable-search", ExpandableSearch);
